import moment from 'moment';
import React, { FC, RefObject } from 'react';
import { DateType } from 'api/models';
import { DatePicker } from 'components/atoms/date-picker';
import { API_DATE_FORMAT } from 'components/atoms/due-date-picker';
import { humanise } from 'components/atoms/humanised-date';
import { DateField } from '../fields';
import { EditableProps } from './editable-props';
import { NoValue } from './no-value';

interface Props extends Partial<EditableProps<DateType>> {
  field?: DateField;
  innerRef?: RefObject<typeof DatePicker>;
  disabledDate?: any;
  value?: string;
  extraFooter?: any;
  allowClear?: boolean;
}

export const DateFieldValue: FC<Props> = ({
  field,
  id,
  editable,
  onChange,
  getPopupContainer,
  className,
  innerRef,
  disabledDate,
  value,
  extraFooter,
  allowClear = true,
}) => {
  return !editable ? (
    field?.value == null || !value ? (
      <NoValue />
    ) : field?.value ? (
      <>{humanise(moment(field?.value))}</>
    ) : (
      <>{humanise(moment(value))}</>
    )
  ) : (
    <DatePicker
      ref={innerRef as any}
      className={className}
      id={id}
      value={
        value
          ? moment(value)
          : field?.value != null
          ? moment(field?.value)
          : null
      }
      onChange={(latest) =>
        onChange?.(latest == null ? undefined : latest.format(API_DATE_FORMAT))
      }
      getPopupContainer={getPopupContainer}
      open
      disabledDate={disabledDate}
      renderExtraFooter={extraFooter}
      allowClear={allowClear}
    />
  );
};
